var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gift 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 9.33333V26.6667M16 9.33333H11.2857C10.5911 9.33333 9.92493 9.05239 9.43377 8.55228C8.9426 8.05219 8.66667 7.37391 8.66667 6.66667C8.66667 5.95943 8.9426 5.28115 9.43377 4.78105C9.92493 4.28095 10.5911 4 11.2857 4C14.9524 4 16 9.33333 16 9.33333ZM16 9.33333H20.7143C21.4089 9.33333 22.0751 9.05239 22.5663 8.55228C23.0573 8.05219 23.3333 7.37391 23.3333 6.66667C23.3333 5.95943 23.0573 5.28115 22.5663 4.78105C22.0751 4.28095 21.4089 4 20.7143 4C17.0476 4 16 9.33333 16 9.33333ZM6.66667 16H25.3333V23.7333C25.3333 25.2268 25.3333 25.9736 25.0427 26.544C24.7871 27.0457 24.3791 27.4537 23.8773 27.7093C23.3069 28 22.5601 28 21.0667 28H10.9333C9.43985 28 8.69312 28 8.12269 27.7093C7.62092 27.4537 7.21297 27.0457 6.95732 26.544C6.66667 25.9736 6.66667 25.2268 6.66667 23.7333V16ZM6.13333 16H25.8667C26.6135 16 26.9868 16 27.272 15.8547C27.5229 15.7268 27.7268 15.5229 27.8547 15.272C28 14.9868 28 14.6135 28 13.8667V11.4667C28 10.7199 28 10.3466 27.8547 10.0613C27.7268 9.81047 27.5229 9.60649 27.272 9.47865C26.9868 9.33333 26.6135 9.33333 25.8667 9.33333H6.13333C5.3866 9.33333 5.01323 9.33333 4.72801 9.47865C4.47713 9.60649 4.27316 9.81047 4.14532 10.0613C4 10.3466 4 10.7199 4 11.4667V13.8667C4 14.6135 4 14.9868 4.14532 15.272C4.27316 15.5229 4.47713 15.7268 4.72801 15.8547C5.01323 16 5.3866 16 6.13333 16Z",
    stroke: "#DFDCED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.c21127dd52839ac47a79b83b7d963298.svg";
export { ForwardRef as ReactComponent };